import React from "react";
import Footer from "../components/Landing/Footer";
import ContactUs from "../components/sop/ContactUs";
import Navbar from "../components/Landing/NewNavbar";
import MetaTags from "../components/generic/MetaTags";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Head from "next/head";

const data = {
  "@context": "http://schema.org",
  "@type": "WebPage",
  name: "Tootler.ai - Contact Us",
  description:
    "Tootler.ai is a free SOP generator that helps you create professional and polished SOPs in minutes. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze. You can also use our plagiarism checker to ensure that your SOPs are original and free of plagiarism. This is important because plagiarism can lead to rejection from schools and employers. Our SOP generator is the perfect tool for anyone who needs to write an SOP. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze.",

  url: "https://tootler.ai/contact-us",

  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": "https://tootler.ai/contact-us",
  },
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Tootle.ai",
        item: "https://tootler.ai/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Contact Us",
        item: "https://tootler.ai/contact-us",
      },
    ],
  },
  FAQs: {
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is SOP writer?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "SOP writer is a software tool that uses artificial intelligence to assist with the creation of Statement of Purpose (SOP). A statement of purpose (SOP) is a written document that outlines an individual's goals, experiences, and qualifications. It is often required as part of a college or graduate school application and is used to help admissions committees understand an applicant's motivations and fit for the program. They are required in the application process for applying for abroad study. The AI-based SOP writer can help to streamline the SOP writing process.",
        },
      },
      {
        "@type": "Question",
        name: "Is SOP writer suitable for all types of SOPs?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "SOP writer can be used for a wide range of SOPs, but currently we are offering it for more or less study visa. That being said we understand that SOPs are needed in a wide range of scenarios that's why the next phase of this product focuses covering all the different domains in terms of SOPs.",
        },
      },
      {
        "@type": "Question",
        name: "Is the output from SOP writer accurate?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "AI generated SOP writers are generally close to perfection, but it is important to carefully review and edit any SOPs generated by this tool to ensure that they are accurate, complete, and meet your organization's specific needs and guidelines. As with any automated tool, it is always a good idea to double-check the output for accuracy and make any necessary corrections.",
        },
      },
      {
        "@type": "Question",
        name: "Can this tool write SOPs from scratch?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "With minimal users to input which would include just a few details about you and some necessary stuff content can be generated by this tool.",
        },
      },
    ],
  },
};

const contactUsPage = () => {
  return (
    <>
      <Head>
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
        <meta
          name="title"
          content="Tootler Al: Contact Us for SOP Writing Help I Tootler AI"
        />
        <meta
          name="description"
          content="Get in touch with Tootler AI's team for best SOP writing help perfect for both professionals and students. Contact us now to unlock your potential!"
        />
        <link rel="canonical" href="https://tootler.ai/contact-us" />
      </Head>
      <MetaTags PageName="Contact Us " />

      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}
      >
        <Navbar className="bg-natural-grey-100" />

        <ContactUs />
        <Footer />
      </GoogleReCaptchaProvider>
    </>
  );
};

export default contactUsPage;
